import { CALL_API } from '../../middleware/api';

export const ROLE_LIST_REQUEST = 'ROLE_LIST_REQUEST';
export const ROLE_LIST_SUCCESS = 'ROLE_LIST_SUCCESS';
export const ROLE_LIST_FAILURE = 'ROLE_LIST_FAILURE';

export const GET_USER_BY_ROLE_NAME_REQUEST = 'GET_USER_BY_ROLE_NAME_REQUEST';
export const GET_USER_BY_ROLE_NAME_SUCCESS = 'GET_USER_BY_ROLE_NAME_SUCCESS';
export const GET_USER_BY_ROLE_NAME_FAILURE = 'GET_USER_BY_ROLE_NAME_FAILURE';


function list() {
    return {
        [CALL_API]: {
            types: [ROLE_LIST_REQUEST, ROLE_LIST_SUCCESS, ROLE_LIST_FAILURE],
            endpoint: 'organization/role/list',
        }
    };
}

export function getUserByRoleName(params) {
    return {
        [CALL_API]: {
            types: [GET_USER_BY_ROLE_NAME_REQUEST, GET_USER_BY_ROLE_NAME_SUCCESS, GET_USER_BY_ROLE_NAME_FAILURE],
            endpoint: 'organization/role/get-user-by-role-name',
            methods: 'GET',
            params
        }
    };
}

export default () => {
    return (dispatch) => {
        return dispatch(list());
    };
};


// WEBPACK FOOTER //
// ./src/action/role/list.js